import { getHostApis } from './getHost'
import debug from '../../utils/console'

const logger = debug.withTag('utils:getSearchUrl')

interface GetSearchUrlOption {
  fallbackUrl: string
  queryPlaceholder: string
}

export interface GetSearchUrl {
  url: string
  isMonetized?: boolean
}

export async function getSearchUrl(
  searchTerm: string,
  options: Partial<GetSearchUrlOption>
): Promise<GetSearchUrl> {
  const { fallbackUrl = '', queryPlaceholder = '{searchTerms}' } = {
    ...options,
  }

  try {
    const generateSearchUrl = (searchUrl: string) =>
      searchUrl.replace(queryPlaceholder, encodeURIComponent(searchTerm))

    const { shift, onelaunch } = getHostApis()

    const newShiftApi = shift?.search?.getDefault
    if (newShiftApi) {
      const searchPreferences = await newShiftApi()
      const isMonetized = searchPreferences.monetized
      const url = generateSearchUrl(searchPreferences.url)
      return { url, isMonetized }
    }

    // TODO: remove after the new api is the standard for most users
    const shiftLegacyApi = shift?.getServerConfig
    if (shiftLegacyApi) {
      const updateServiceSettings = await shiftLegacyApi()
      return { url: generateSearchUrl(updateServiceSettings.search_url) }
    }

    const onelaunchApi = onelaunch?.getMergedData
    if (onelaunchApi) {
      const updateServiceSettings = await onelaunchApi()
      return { url: generateSearchUrl(updateServiceSettings.search_url) }
    }

    return { url: generateSearchUrl(fallbackUrl) }
  } catch (e) {
    logger.error(e)
    return { url: fallbackUrl }
  }
}
